/* =========================================================
   Custom Product Page — Mobrio / Dawn 15.4.0
   Aislado. No modifica media-gallery.js ni variant-cards.js.
   Galería: hover-swap, transición lateral, flechas propias,
   indicador carrusel de 5 clicable, scroll-trap, thumbs con
   altura = imagen, sync total. Reinicializable.
========================================================= */
(function () {
  'use strict';
  /* Bloquea el scrollIntoView de Dawn dentro del carrusel de color
     (Dawn lo usa al cambiar variante y resetea la posición del track) */
  (function () {
    if (window.__ccScrollGuard) return;
    window.__ccScrollGuard = true;
    var original = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function (opts) {
      try {
        if (this.closest && this.closest('.color-carousel__track')) {
          return; // no dejar que Dawn resetee el carrusel de color
        }
      } catch (e) {}
      return original.apply(this, arguments);
    };
  })();
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP = window.matchMedia('(min-width: 750px)');

  function initSection(sectionEl) {
    if (!sectionEl) return;
    var productInfo = sectionEl.matches('product-info')
      ? sectionEl
      : sectionEl.querySelector('product-info');
    if (!productInfo) return;
    if (productInfo.dataset.cppInit === '1') return;
    productInfo.dataset.cppInit = '1';

    var sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    var gallery = productInfo.querySelector('media-gallery');
    var viewer = gallery ? gallery.querySelector('[id^="GalleryViewer"]') : null;

    /* ================= GALERÍA ================= */
    if (gallery && viewer && typeof gallery.setActiveMedia === 'function') {
      var thumbWrap = gallery.querySelector('[id^="GalleryThumbnails"]');
      var thumbList = thumbWrap ? thumbWrap.querySelector('.thumbnail-list') : null;
      var animating = false;

      var items = function () {
        return Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
      };
      var getIndex = function (mediaId) {
        return items().findIndex(function (el) { return el.dataset.mediaId === mediaId; });
      };
      var activeId = function () {
        var a = viewer.querySelector('.product__media-item.is-active');
        return a ? a.dataset.mediaId : null;
      };

      /* ---- Marca thumb activa AL INSTANTE ---- */
      var markActiveThumb = function (mediaId) {
        if (!thumbWrap) return;
        thumbWrap.querySelectorAll('.thumbnail[aria-current]').forEach(function (b) {
          b.removeAttribute('aria-current');
        });
        var t = thumbWrap.querySelector('[data-target="' + mediaId + '"] .thumbnail')
          || thumbWrap.querySelector('[data-target="' + mediaId + '"] button');
        if (t) t.setAttribute('aria-current', 'true');
      };

      /* ---- Transición lateral + cambio de media ---- */
      var slideTo = function (target) {
        if (!DESKTOP.matches || REDUCED_MOTION) {
          markActiveThumb(target);
          gallery.setActiveMedia(target, false);
          return;
        }
        var current = viewer.querySelector('.product__media-item.is-active');
        if (!current || current.dataset.mediaId === target) return;

        markActiveThumb(target); // borde INSTANTÁNEO

        var dir = getIndex(target) > getIndex(current.dataset.mediaId) ? 1 : -1;
        var targetItem = viewer.querySelector('[data-media-id="' + target + '"]');
        var img = targetItem ? targetItem.querySelector('img') : null;
        if (!img) { gallery.setActiveMedia(target, false); return; }

        var prev = viewer.querySelector('.cpp-slide-overlay');
        if (prev) prev.remove();

        var overlay = document.createElement('div');
        overlay.className = 'cpp-slide-overlay';
        var clone = document.createElement('img');
        clone.src = img.currentSrc || img.src;
        clone.style.transform = 'translateX(' + (dir * 100) + '%)';
        clone.style.transition = 'none';
        overlay.appendChild(clone);
        viewer.appendChild(overlay);

        animating = true;
        requestAnimationFrame(function () {
          clone.style.transition = 'transform 0.55s cubic-bezier(0.16, 1, 0.3, 1)';
          clone.style.transform = 'translateX(0)';
        });
        var done = function () {
          gallery.setActiveMedia(target, false);
          overlay.remove();
          animating = false;
        };
        clone.addEventListener('transitionend', done, { once: true });
        setTimeout(function () { if (animating) done(); }, 700);
      };
      productInfo._cppSlideTo = slideTo;

      /* ---- Navegación relativa ---- */
      var navRelative = function (step) {
        var list = items();
        var idx = list.findIndex(function (el) { return el.dataset.mediaId === activeId(); });
        if (idx < 0) return;
        var next = idx + step;
        if (next < 0 || next >= list.length) return;
        slideTo(list[next].dataset.mediaId);
      };

      /* ---- FLECHAS PROPIAS ---- */
      try {
        viewer.querySelectorAll(':scope > .slider-buttons').forEach(function (g) {
          g.style.display = 'none';
        });
      } catch (e) {}

      var makeArrow = function (dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cpp-arrow cpp-arrow--' + (dir < 0 ? 'prev' : 'next');
        btn.setAttribute('aria-label', dir < 0 ? 'Imagen anterior' : 'Imagen siguiente');
        btn.innerHTML = dir < 0
          ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>'
          : '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          navRelative(dir);
        });
        return btn;
      };

      var prevBtn = makeArrow(-1);
      var nextBtn = makeArrow(1);
      viewer.appendChild(prevBtn);
      viewer.appendChild(nextBtn);

      productInfo._cppUpdateArrows = function () {
        var list = items();
        var idx = list.findIndex(function (el) { return el.dataset.mediaId === activeId(); });
        prevBtn.toggleAttribute('disabled', idx <= 0);
        nextBtn.toggleAttribute('disabled', idx >= list.length - 1);
      };
      try { productInfo._cppUpdateArrows(); } catch (e) {}

      /* ---- Click en thumbnails (sin hover) ---- */
      if (thumbWrap) {
        thumbWrap.querySelectorAll('[data-target]').forEach(function (item) {
          var btn = item.querySelector('button') || item;
          btn.addEventListener('click', function (e) {
            if (!DESKTOP.matches) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            slideTo(item.dataset.target);
          }, true);
        });
      }

      /* ---- Scroll-trap vertical en thumbs ---- */
      if (thumbList) {
        thumbList.addEventListener('wheel', function (e) {
          if (!DESKTOP.matches) return;
          var atTop = thumbList.scrollTop <= 0;
          var atBottom = thumbList.scrollTop + thumbList.clientHeight >= thumbList.scrollHeight - 1;
          var down = e.deltaY > 0;
          if ((down && !atBottom) || (!down && !atTop)) {
            e.preventDefault();
            thumbList.scrollTop += e.deltaY;
          }
        }, { passive: false });
      }

      /* ---- Fade inferior "hay más imágenes" ---- */
      if (thumbWrap && thumbList) {
        var updateFade = function () {
          var hasScroll = thumbList.scrollHeight > thumbList.clientHeight + 2;
          thumbWrap.classList.toggle('cpp-has-more', hasScroll);
          var atBottom = thumbList.scrollTop + thumbList.clientHeight >= thumbList.scrollHeight - 2;
          thumbWrap.classList.toggle('cpp-at-bottom', atBottom);
        };
        thumbList.addEventListener('scroll', updateFade);
        setTimeout(updateFade, 350);
        window.addEventListener('resize', function () { setTimeout(updateFade, 100); });
        productInfo._cppUpdateFade = updateFade;
      }

      /* ---- Autoscroll a thumb activa ---- */
      productInfo._cppScrollToActive = function () {
        if (!thumbList || !DESKTOP.matches) return;
        var active = thumbWrap.querySelector('[aria-current]');
        var li = active ? active.closest('.thumbnail-list__item') : null;
        if (li) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      };

      /* ---- Altura de la columna de thumbs = altura real del viewer ---- */
      var syncThumbHeight = function () {
        if (!thumbList || !DESKTOP.matches) {
          if (thumbList) { thumbList.style.height = ''; thumbList.style.maxHeight = ''; }
          return;
        }
        var h = viewer.getBoundingClientRect().height;
        if (h > 0) {
          thumbList.style.height = h + 'px';
          thumbList.style.maxHeight = h + 'px';
        }
        if (productInfo._cppUpdateFade) productInfo._cppUpdateFade();
      };
      try { syncThumbHeight(); } catch (e) {}
      productInfo._cppSyncThumbHeight = syncThumbHeight;
      if ('ResizeObserver' in window) {
        try {
          var roThumb = new ResizeObserver(function () {
            try { syncThumbHeight(); } catch (e) {}
          });
          roThumb.observe(viewer);
          productInfo._cppThumbResize = roThumb;
        } catch (e) {}
      }
      window.addEventListener('resize', function () {
        try { syncThumbHeight(); } catch (e) {}
      });
    }

    /* ================= INDICADOR (carrusel 5, clicable) ================= */
    var indicator = productInfo.querySelector('.cpp-gallery-indicator');
    if (indicator && viewer) {
      if (DESKTOP.matches && indicator.parentElement !== viewer.parentElement) {
        if (viewer.nextSibling) viewer.parentElement.insertBefore(indicator, viewer.nextSibling);
        else viewer.parentElement.appendChild(indicator);
      }

      var WINDOW = 5;

      var buildDots = function () {
        var list = viewer.querySelectorAll('.product__media-item');
        indicator.innerHTML = '';
        var viewport = document.createElement('div');
        viewport.className = 'cpp-gallery-indicator__viewport';
        var track = document.createElement('div');
        track.className = 'cpp-gallery-indicator__track';
        list.forEach(function (item) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cpp-gallery-indicator__dot';
          dot.dataset.mediaId = item.dataset.mediaId;
          dot.setAttribute('aria-label', 'Ver imagen');
          dot.addEventListener('click', function () {
            if (productInfo._cppSlideTo) productInfo._cppSlideTo(item.dataset.mediaId);
            else gallery.setActiveMedia(item.dataset.mediaId, false);
          });
          track.appendChild(dot);
        });
        viewport.appendChild(track);
        indicator.appendChild(viewport);
        indicator._track = track;
        indicator._total = list.length;
        syncIndicator();
      };

      var applyActive = function (id) {
        var dots = indicator.querySelectorAll('.cpp-gallery-indicator__dot');
        var activeIdx = -1;
        dots.forEach(function (dot, i) {
          var on = dot.dataset.mediaId === id;
          dot.classList.toggle('is-active', on);
          if (on) activeIdx = i;
        });
        var total = indicator._total || dots.length;
        var track = indicator._track;
        if (track && total > WINDOW && activeIdx >= 0) {
          var start = Math.min(Math.max(activeIdx - Math.floor(WINDOW/2), 0), total - WINDOW);
          track.style.transform = 'translateX(' + (-(start * (8 + 0.9*16))) + 'px)';
          dots.forEach(function (dot, i) {
            var edge = (i === start && start > 0) || (i === start + WINDOW - 1 && start + WINDOW < total);
            dot.classList.toggle('is-edge', edge && !dot.classList.contains('is-active'));
          });
        } else if (track) {
          track.style.transform = 'translateX(0)';
        }
      };

      var syncIndicator = function () {
        var a = viewer.querySelector('.product__media-item.is-active');
        var id = a ? a.dataset.mediaId : null;
        if (indicator._swipeActiveId && id !== indicator._swipeActiveId) {
          id = indicator._swipeActiveId;
        }
        applyActive(id);
        if (productInfo._cppScrollToActive) productInfo._cppScrollToActive();
        if (productInfo._cppUpdateArrows) productInfo._cppUpdateArrows();
        if (productInfo._cppSyncThumbHeight) productInfo._cppSyncThumbHeight();
      };

      buildDots();

      var mo = new MutationObserver(function (m) {
        if (m.some(function (x) { return x.attributeName === 'class'; })) syncIndicator();
      });
      viewer.querySelectorAll('.product__media-item').forEach(function (item) {
        mo.observe(item, { attributes: true, attributeFilter: ['class'] });
      });
      var moList = new MutationObserver(function () {
        buildDots();
        viewer.querySelectorAll('.product__media-item').forEach(function (item) {
          mo.observe(item, { attributes: true, attributeFilter: ['class'] });
        });
      });
      moList.observe(viewer, { childList: true });
      // Swipe móvil: el swipe manda sobre .is-active
      viewer.addEventListener('slideChanged', function (e) {
        var mediaId = (e.detail && e.detail.currentElement)
          ? e.detail.currentElement.dataset.mediaId : null;
        if (!mediaId) return;
        indicator._swipeActiveId = mediaId;
        applyActive(mediaId);
      });
      productInfo._cppObservers = [mo, moList];
    }

    /* ================= STICKY ADD TO CART ================= */
    var stickyBar = productInfo.querySelector('.cpp-sticky-atc');
    var mainBtn = productInfo.querySelector('#ProductSubmitButton-' + sectionId);
    if (stickyBar && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
stickyBar.classList.toggle('is-visible', !entry.isIntersecting);        });
      }, { root: null, threshold: 0, rootMargin: '0px 0px -80px 0px' });
      io.observe(mainBtn);
      productInfo._cppIO = io;
      var stickyBtn = stickyBar.querySelector('.cpp-sticky-atc__button');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var live = productInfo.querySelector('#ProductSubmitButton-' + sectionId);
          if (live) live.click();
        });
      }
    }

    var syncSticky = function () {
      if (!stickyBar) return;
      var priceSource = productInfo.querySelector('#price-' + sectionId + ' .price__container')
        || productInfo.querySelector('#price-' + sectionId);
      var priceTarget = stickyBar.querySelector('.cpp-sticky-atc__price');
      if (priceSource && priceTarget) {
        var sale = priceSource.querySelector('.price-item--sale, .price-item--regular');
        priceTarget.textContent = sale ? sale.textContent.trim() : priceSource.textContent.trim();
      }
      var live = productInfo.querySelector('#ProductSubmitButton-' + sectionId);
      var sBtn = stickyBar.querySelector('.cpp-sticky-atc__button');
      if (live && sBtn) {
        sBtn.toggleAttribute('disabled', live.hasAttribute('disabled'));
        var ll = live.querySelector('span'), sl = sBtn.querySelector('span');
        if (ll && sl) sl.textContent = ll.textContent.trim();
      }
    };
    syncSticky();
    var priceBlock = productInfo.querySelector('#price-' + sectionId);
    if (priceBlock && stickyBar) {
      var moPrice = new MutationObserver(syncSticky);
      moPrice.observe(priceBlock, { childList: true, subtree: true });
      productInfo._cppPriceObserver = moPrice;
    }
  }

  function initAll() {
    document.querySelectorAll('product-info[data-section]').forEach(initSection);
  }
  function boot() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('media-gallery').then(initAll);
    } else {
      initAll();
    }
    // Reintento de seguridad por si el upgrade llega tarde
    setTimeout(initAll, 300);
    setTimeout(initAll, 1000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
    /* ================= DRAG-TO-SCROLL carrusel de variantes ================= */
  /* ============ Carrusel de color: drag-scroll + indicador ━━ • ============ */
  function initColorCarousel() {
    document.querySelectorAll('.cpp-info-card .color-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.color-carousel__track');
      if (!track || track.dataset.ccInit === '1') return;
      track.dataset.ccInit = '1';

      /* --- Drag to scroll (sin capturar el puntero hasta que haya movimiento) --- */
      var isDown = false, startX = 0, startScroll = 0, moved = false, captured = false;
      var lastX = 0, lastT = 0, velocity = 0, rafId = null, pointerId = null;
      track.style.cursor = 'grab';

      var cancelMomentum = function () {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      };

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.button !== 0) return; // solo botón izquierdo
        isDown = true; moved = false; captured = false;
        startX = e.clientX;
        lastX = e.clientX;
        lastT = performance.now();
        velocity = 0;
        pointerId = e.pointerId;
        startScroll = track.scrollLeft;
        cancelMomentum();
        // NO capturamos aquí — dejamos el click limpio intacto
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        // Solo activamos el modo arrastre tras movimiento real (>5px)
        if (!captured && Math.abs(dx) > 5) {
          captured = true;
          moved = true;
          track.style.cursor = 'grabbing';
          track.style.scrollBehavior = 'auto';
          track.style.scrollSnapType = 'none';
          try { track.setPointerCapture(pointerId); } catch (err) {}
        }
        if (!captured) return; // aún no es arrastre → no hacemos nada
        track.scrollLeft = startScroll - dx;
        var now = performance.now();
        var dt = now - lastT;
        if (dt > 0) velocity = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastT = now;
      });

      var endDrag = function (e) {
        if (!isDown) return;
        isDown = false;
        track.style.cursor = 'grab';
        if (captured) {
          try { track.releasePointerCapture(pointerId); } catch (err) {}
          var v = velocity * 16;
          var momentum = function () {
            if (Math.abs(v) < 0.5) {
              track.style.scrollSnapType = '';
              track.style.scrollBehavior = '';
              rafId = null;
              return;
            }
            track.scrollLeft -= v;
            v *= 0.92;
            rafId = requestAnimationFrame(momentum);
          };
          cancelMomentum();
          if (Math.abs(v) > 1) rafId = requestAnimationFrame(momentum);
          else { track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; }

          // bloquea el click inmediato solo si hubo arrastre real
          track.dataset.justDragged = '1';
          setTimeout(function () { track.dataset.justDragged = '0'; }, 50);
        }
        captured = false;
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* --- Indicador ━━ • --- */
      var PAGES = 2; // nº de "páginas" del indicador (línea + puntos)
      var indicator = document.createElement('div');
      indicator.className = 'cc-indicator';
      for (var i = 0; i < PAGES; i++) {
        var dot = document.createElement('span');
        dot.className = 'cc-indicator__dot';
        indicator.appendChild(dot);
      }
      carousel.appendChild(indicator);

      var updateIndicator = function () {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) { indicator.style.display = 'none'; return; }
        indicator.style.display = 'flex';
        var ratio = track.scrollLeft / max;             // 0 → 1
        var active = Math.round(ratio * (PAGES - 1));    // página activa
        indicator.querySelectorAll('.cc-indicator__dot').forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === active);
        });
      };
      track.addEventListener('scroll', function () {
        updateIndicator();
        window.__ccLastScroll = track.scrollLeft;
      });
      updateIndicator();
      window.addEventListener('resize', updateIndicator);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorCarousel);
  } else {
    initColorCarousel();
  }
  document.addEventListener('shopify:section:load', initColorCarousel);
    /* ====== Carrusel de color → selecciona la variante en el <select> real ====== */
  function initColorCarouselSelect() {
    document.querySelectorAll('.has-color-carousel').forEach(function (wrap) {
      var select = wrap.querySelector('select[name="options[Color]"]')
        || wrap.querySelector('select');
      var carousel = wrap.querySelector('.color-carousel');
      if (!select || !carousel || carousel.dataset.selInit === '1') return;
      carousel.dataset.selInit = '1';

      carousel.querySelectorAll('.color-carousel__item').forEach(function (item) {
        item.addEventListener('click', function () {
          var tk = carousel.querySelector('.color-carousel__track');
          if (tk && tk.dataset.justDragged === '1') return;
          var value = item.dataset.value;
          if (!value) return;

          carousel.querySelectorAll('.color-carousel__item').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          item.classList.add('is-selected');
          item.setAttribute('aria-pressed', 'true');

          // Guarda posición en el wrap (sobrevive al re-render)
          wrap.dataset.savedScroll = tk ? tk.scrollLeft : 0;

          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // Restaura agresivamente durante 800ms
          var saved = parseFloat(wrap.dataset.savedScroll) || 0;
          var until = performance.now() + 800;
          var pin = function () {
            var t = wrap.querySelector('.color-carousel__track');
            if (t) {
              t.style.scrollBehavior = 'auto';
              if (Math.abs(t.scrollLeft - saved) > 1) t.scrollLeft = saved;
            }
            if (performance.now() < until) requestAnimationFrame(pin);
            else if (t) t.style.scrollBehavior = '';
          };
        requestAnimationFrame(pin);
      });   
    }); 
  });   
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorCarouselSelect);
  } else {
    initColorCarouselSelect();
  }
  document.addEventListener('shopify:section:load', initColorCarouselSelect);

     /* ===== Montaje del carrusel en el anchor + selección de variante ===== */
  (function () {


    /* Selección de variante — listener global delegado (sobrevive re-renders) */
    document.addEventListener('click', function (e) {
      var item = e.target.closest('.color-carousel__item');
      if (!item) return;
      var carousel = item.closest('.color-carousel');
      var track = carousel ? carousel.querySelector('.color-carousel__track') : null;
      if (track && track.dataset.justDragged === '1') return;

      var value = item.dataset.value;
      var select = document.querySelector('variant-selects select[name="options[Color]"]')
        || document.querySelector('variant-selects select[name^="options"]');
      if (!select || !value) return;

      if (track) window.__ccLastScroll = track.scrollLeft;

      carousel.querySelectorAll('.color-carousel__item').forEach(function (b) {
        b.classList.toggle('is-selected', b === item);
        b.setAttribute('aria-pressed', b === item ? 'true' : 'false');
      });
      // Actualiza el título del color al instante
      var heading = carousel.querySelector('.color-carousel__selected');
      if (heading) heading.textContent = value;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();
    /* Oculta el label de Color viejo (su título va en el carrusel) */
  (function () {
    function hideColorLabel() {
      document.querySelectorAll('.product-form__input--dropdown .form__label').forEach(function (lbl) {
        var txt = lbl.textContent.toLowerCase();
        if (txt.indexOf('color') !== -1 && document.querySelector('.color-carousel')) {
          lbl.style.display = 'none';
        }
      });
    }
    hideColorLabel();
    document.addEventListener('shopify:section:load', hideColorLabel);
  })();
  /* =========================================================
     Descripciones → mover a columna (desktop) + acordeón unificado
  ========================================================= */
  (function () {
    function makeItem(title, innerHTML) {
      var item = document.createElement('div');
      item.className = 'cpp-acc-item';
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'cpp-acc-header';
      btn.textContent = title || '';
      var icon = document.createElement('span'); icon.className = 'cpp-acc-icon';
      btn.appendChild(icon);
      var panel = document.createElement('div'); panel.className = 'cpp-acc-panel';
      var inner = document.createElement('div'); inner.className = 'cpp-acc-panel__inner';
      inner.innerHTML = innerHTML;
      panel.appendChild(inner);
      item.appendChild(btn); item.appendChild(panel);
      wire(item);
      return item;
    }
    function wire(item) {
      var header = item.querySelector('.cpp-acc-header');
      var panel = item.querySelector('.cpp-acc-panel');
      header.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        panel.style.transition = 'none';
        panel.style.height = panel.offsetHeight + 'px';
        void panel.offsetHeight;
        panel.style.transition = 'height 0.35s cubic-bezier(0.16,1,0.3,1)';
        if (open) {
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          item.classList.remove('is-open');
        } else {
          item.classList.add('is-open');
          requestAnimationFrame(function () {
            panel.style.height = panel.querySelector('.cpp-acc-panel__inner').offsetHeight + 'px';
          });
          panel.addEventListener('transitionend', function te() {
            if (item.classList.contains('is-open')) panel.style.height = 'auto';
            panel.removeEventListener('transitionend', te);
          });
        }
      });
    }

    function process() {
      var card = document.querySelector('.cpp-info-card');
      if (!card) return;
      var isDesktop = window.matchMedia.matches;

      // Recolecta TODAS las secciones de descripción presentes
      var sections = [];
      document.querySelectorAll('.product-desc-optimized').forEach(function (el) {
        sections.push({ node: el.closest('.shopify-section') || el, type: 'optim', el: el });
      });
      document.querySelectorAll('[id^="product-info-apple-"]').forEach(function (el) {
        sections.push({ node: el.closest('.shopify-section') || el, type: 'apple', el: el });
      });
      document.querySelectorAll('.tech-specs').forEach(function (el) {
        sections.push({ node: el.closest('.shopify-section') || el, type: 'tech', el: el });
      });

      sections.forEach(function (s) {
        // 1) Mover a la columna en desktop (si no está ya)
        if (s.node && !card.contains(s.node) && s.node.dataset.cppMoved !== '1') {
          s.node.dataset.cppMoved = '1';
          card.appendChild(s.node);
        }
        // 2) Construir acordeón (si no está ya)
        if (s.el.dataset.cppAcc === '1') return;

        if (s.type === 'optim') {
          var blocks = s.el.querySelectorAll('.desc-block');
          if (!blocks.length) return;
          s.el.dataset.cppAcc = '1';
          var c1 = document.createElement('div'); c1.className = 'cpp-acc';
          blocks.forEach(function (block) {
            var h = block.querySelector('h3');
            var title = h ? h.textContent.trim() : 'Descripción';
            var clone = block.cloneNode(true);
            if (clone.querySelector('h3')) clone.querySelector('h3').remove();
            c1.appendChild(makeItem(title, clone.innerHTML));
          });
          var host = s.el.querySelector('.desc-content') || s.el;
          host.innerHTML = ''; host.appendChild(c1);

        } else if (s.type === 'apple') {
          var oldItems = s.el.querySelectorAll('.apple-acc__item');
          if (!oldItems.length) return;
          s.el.dataset.cppAcc = '1';
          var c2 = document.createElement('div'); c2.className = 'cpp-acc';
          oldItems.forEach(function (old) {
            var t = old.querySelector('.apple-acc__title');
            var lbl = old.querySelector('.apple-acc__label');
            var ct = old.querySelector('.apple-acc__content');
            var title = t ? t.textContent.trim() : '';
            var inner = '';
            if (lbl && lbl.textContent.trim()) inner += '<div class="cpp-acc-subtitle">' + lbl.innerHTML + '</div>';
            inner += ct ? ct.innerHTML : '';
            c2.appendChild(makeItem(title, inner));
          });
          var list = s.el.querySelector('.apple-acc__list') || s.el.querySelector('.apple-acc__inner') || s.el;
          list.innerHTML = ''; list.appendChild(c2);

        } else if (s.type === 'tech') {
          var table = s.el.querySelector('.specs-table');
          if (!table) return;
          s.el.dataset.cppAcc = '1';
          var c3 = document.createElement('div'); c3.className = 'cpp-acc';
          c3.appendChild(makeItem('Características técnicas', table.outerHTML));
          var cont = s.el.querySelector('.container') || s.el;
          cont.innerHTML = ''; cont.appendChild(c3);
        }
      });
    }

    process();
    document.addEventListener('shopify:section:load', process);
    window.addEventListener('resize', function () {
      clearTimeout(window._cppDescT);
      window._cppDescT = setTimeout(process, 200);
    });
  })();
})();